import { AxiosResponse } from "axios";

import API from "../api";

import { Translate } from "../models/translate.type";

const ROUTE_NAME = "translates";

const TranslateService = {
  async getDefaultTranslate(): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/2`);
  },
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Translate[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(translate: Translate): Promise<AxiosResponse<Translate>> {
    return await API.post(`/${ROUTE_NAME}`, translate);
  },
  async update(id: number, Translate: Translate): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, Translate);
  },
  async delete(id: number): Promise<AxiosResponse<Translate>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default TranslateService;
